import type {
  PaginatedRecordsResponseDTO,
  RecordsFiltersDTO,
} from "@/application/records/dtos/RecordListItemDTO";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";

export interface FetchRecordsPaginatedInputDto {
  page: number;
  limit: number;
  filters?: RecordsFiltersDTO;
}

/**
 * Use case: загрузка пользовательских записей с пагинацией.
 * Чистая архитектура — Application layer.
 */
export class FetchRecordsPaginatedUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchRecordsPaginatedInputDto
  ): Promise<PaginatedRecordsResponseDTO> {
    const { page, limit, filters } = input;
    return this.gateway.getRecordsPaginated(page, limit, filters);
  }
}
